import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSnackbar } from "./SnackbarHandler";

const SharePodcastDialog = ({ open, onClose, podcastId }) => {
  const [copied, setCopied] = useState(false);
  const { showSnackbar } = useSnackbar();

  // Create the shareable link
  const podcastUrl = `${window.location.origin}/app/podcast/${podcastId}?v=t`;

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(podcastUrl)
      .then(() => {
        setCopied(true);
        showSnackbar("Länk kopierad till urklipp!", "success");
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((err) => {
        console.error("Failed to copy link:", err);
        showSnackbar("Kunde inte kopiera länken", "error");
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
          maxWidth: "500px",
          width: "100%",
        },
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Dela podcast</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Kopiera länken nedan för att dela podcasten:
        </Typography>
        <TextField
          fullWidth
          value={podcastUrl}
          variant="outlined"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopyLink} color="primary">
                  {copied ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <ContentCopyIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button onClick={onClose} variant="print">
          Stäng
        </Button>
        <Button onClick={handleCopyLink} variant="purp" sx={{ ml: 2 }}>
          Kopiera länk
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SharePodcastDialog;
